import LYCom from "@/common/LYCom.js";
import moment from "moment"
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
let LYUtils = {
  //价格保留小数点位数
  getPrice(price, number = 2) {
    if (price) {
      if (number == 1) {
        return price.toFixed(number)
      } else {
        return (price * 1 / 100).toFixed(number)
      }
    } else {
      return 0
    }
  },
  GetFileUrl(Url, IsNeedHeadUrl = true) {
    var regx = /(http|https):\/\/([\w.]+\/?)\S*/;
    if (!Url) {
      return null;
    }
    if (IsNeedHeadUrl) {
      if (Url.match(regx) || this.IsBase64(Url)) {
        return Url;
      }
      return LYCom.GetSvrById("OssImgUrl").Address + Url;
    } else {
      return Url;
    }
  },
  IsBase64(str) {
    if (str.indexOf('data:') != -1 && str.indexOf('base64') != -1) {
      return true;
    } else {
      return false;
    }
  },
  // 表情包解码
  entitiestoUtf16(strObj) {
    if (!strObj) {
      return
    }
    var patt = /&#\d+;/g;
    var H, L, code;
    var arr = strObj.match(patt) || [];
    for (var i = 0; i < arr.length; i++) {
      code = arr[i];
      code = code.replace("&#", "").replace(";", "");
      H = Math.floor((code - 0x10000) / 0x400) + 0xd800; // 计算高位
      L = ((code - 0x10000) % 0x400) + 0xdc00; // 计算低位
      code = "&#" + code + ";";
      var s = String.fromCharCode(H, L);
      strObj = strObj.replace(code, s);
    }
    return strObj;
  },
  utf16toEntities(str) {
    if (!str) return
    var patt = /[\ud800-\udbff][\udc00-\udfff]/g; // 检测utf16字符正则
    str = str.replace(patt, function (char) {
      var H, L, code;
      if (char.length === 2) {
        H = char.charCodeAt(0); // 取出高位
        L = char.charCodeAt(1); // 取出低位
        code = (H - 0xD800) * 0x400 + 0x10000 + L - 0xDC00; // 转换算法
        return "&#" + code + ";";
      } else {
        return char;
      }
    });
    return str;
  },
  // 时间格式化
  momentTime: function (date, format = "YYYY-MM-DD") {
    if (date) {
      return moment(date).format(format)
    } else {
      return ''
    }

  },
  uploadHearders() {
    let token = window.sessionStorage.getItem("token");
    let headers = {
      'ly-token': token

    }
    return headers

  },
  getFileUrl(Id) {
    let address = LYCom.SvrCfg.find(item => item.Id == Id)
    return address.Address
  },
  // 获取guid 唯一标识
  guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  },
  dataURLtoFile: function (dataurl, filename) { //将base64转换为文件
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {
      type: mime
    });
  },
  // 通过性别编号获取性别名称
  getSexName(sex) {
    return sex ? sex == 1 ? '男' : '女' : '未知'
  },
  // 上传附件token配置
  updateFileHearders() {
    let token = window.sessionStorage.getItem("token");

    return {
      'ly-token': token
    }
  },
  dataURLToBlob(dataurl) {
    let arr = dataurl.split(",");
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
      type: mime
    });
  },
  // html转图片下载
  exportImg(fileName) {
    let a = document.createElement("a");
    html2canvas(document.querySelector("#printDom")).then((canvas) => {
      let dom = document.body.appendChild(canvas);
      dom.style.display = "none";
      a.style.display = "none";
      document.body.removeChild(dom);
      let blob = LYUtils.dataURLToBlob(dom.toDataURL("image/png"));
      a.setAttribute("href", URL.createObjectURL(blob));
      //这块是保存图片操作  可以设置保存的图片的信息
      a.setAttribute("download", fileName + ".png");
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(blob);
      document.body.removeChild(a);
    });
  },

  // html转pdf下载
  exportPdf(fileName) {
    let a = document.createElement("a");
    html2canvas(document.querySelector("#printDom"), {
      scale: 4
    }).then((canvas) => {
      let dom = document.body.appendChild(canvas);
      dom.style.display = "none";
      a.style.display = "none";
      var contentWidth = canvas.width - 20;
      var contentHeight = canvas.height;
      //一页pdf显示html页面生成的canvas高度;
      var pageHeight = (contentWidth / 572.28) * 821.89;
      //未生成pdf的html页面高度
      var leftHeight = contentHeight;
      //页面偏移
      var position = 20;
      //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
      var imgWidth = 557.28;
      var imgHeight = (572.28 / contentWidth) * contentHeight;

      var pageData = canvas.toDataURL("image/JPEG", 1.0);

      var pdf = new jsPDF("", "pt", "a4");

      //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
      //当内容未超过pdf一页显示的范围，无需分页
      if (leftHeight < pageHeight) {
        pdf.addImage(pageData, "JPEG", 20, 20, imgWidth, imgHeight);
      } else {
        while (leftHeight > 0) {
          pdf.addImage(pageData, "JPEG", 20, position, imgWidth, imgHeight);
          leftHeight -= pageHeight;
          position -= 841.89;
          //避免添加空白页
          if (leftHeight > 0) {
            pdf.addPage();
          }
        }
      }
      pdf.save(fileName + ".pdf");
    });
  },
  getNameByNumber(number) {
    switch (number) {
      case 1:
        return "A"
        break;
      case 2:
        return "B"
        break;
      case 3:
        return "C"
        break;
      case 4:
        return "D"
        break;

      case 5:
        return "E"
        break;

      case 6:
        return "F"
        break;
    }

  },
  // 获取审核状态名称
  getCheckStatusName(checkStatus) {
    switch (checkStatus) {
      case 0:
        return "待商家确认"
      case 1:
        return "已通过"
      case 2:
        return "已驳回"
      case 3:
        return "已取消"
    }
  },
  //售后类型名称
  getAfterSaleName(afterSaleType) {
    switch (afterSaleType) {
      case 1:
        return "仅退款";

      case 2:
        return "退款退货";

      case 3:
        return "换货";
    }
  },
  // 根据status获取名称
  getStatusName(status) {
    // 订单状态（1：待付款；2已取消；3待发货(已付款)；4待收货（已付款）；5：待评价；6：商家审核中；7退货中；8换货中；9订单已完成；10售后已完成）
    switch (status) {
      case 1:
        return "待付款";

      case 2:
        return "已取消";

      case 3:
        return "待发货";

      case 4:
        return "待收货";

      case 5:
        return "待评价";

      case 6:
        return "待商家确认";

      case 7:
        return "退货中";

      case 8:
        return "换货中";

      case 9:
        return "订单已完成";

      case 10:
        return "已完成";
      case 12:
        return "已驳回";
    }
  },
  // 量表订单根据status获取名称
  getScaleStatusName(status) {
    switch (status) {
      case 1:
        return "待支付";

      case 2:
        return "已取消";

      case 3:
        return "已付款";

      case 4:
        return "待评价";

      case 5:
        return "已退款";

      case 6:
        return "已完成";
    }
  },

}

export default LYUtils



// WEBPACK FOOTER //
// ./src/common/LYUtils.js